<template>
  <footer class="border-t border-black bg-tw-cream">
    <div class="mx-auto flex max-w-[1280px] flex-col gap-8 py-12 pr-6 lg:flex-row lg:items-start lg:justify-between lg:py-[49px] lg:pr-12">
      <!-- The source logo has wide white margins; crop to the mark as in the design and blend the white into the cream -->
      <img :src="uioLogo" :alt="t('uio')" class="h-[67px] w-[356px] max-w-full object-cover mix-blend-multiply" />
      <div class="flex flex-col gap-6 pl-6 lg:items-end lg:pl-0">
        <nav :aria-label="t('navLabel')">
          <ul class="flex flex-col gap-2 font-semibold text-tw-ink sm:flex-row sm:flex-wrap sm:gap-x-[19px] lg:justify-end">
            <li v-for="link in links" :key="link.to">
              <router-link
                :to="link.to"
                class="leading-8 hover:text-tw-rust hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tw-rust [&.router-link-exact-active]:underline"
              >
                {{ t(link.label) }}
              </router-link>
            </li>
          </ul>
        </nav>
        <PillLink class="self-start lg:self-end" href="https://nettskjema.no/a/samtavla-tilbakemelding" external>{{ t('feedback') }}</PillLink>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import uioLogo from '@/assets/landing/uio-logo.png'
  import PillLink from './PillLink.vue'

  const links = [
    { to: '/kontakt', label: 'contact' },
    { to: '/lisens', label: 'license' },
    { to: '/tilgjengelighet', label: 'accessibility' },
    { to: '/personvern', label: 'privacy' },
    { to: '/sporsmal', label: 'faq' },
  ]

  const { t } = useI18n({
    messages: {
      no: {
        uio: 'Universitetet i Oslo',
        navLabel: 'Bunntekst',
        contact: 'Kontakt oss',
        license: 'Lisens for Samtavla',
        accessibility: 'Tilgjengelighetserklæring',
        privacy: 'Personvernerklæring',
        faq: 'Ofte stilte spørsmål',
        feedback: 'Gi oss tilbakemelding om Samtavla',
      },
      en: {
        uio: 'University of Oslo',
        navLabel: 'Footer',
        contact: 'Contact us',
        license: 'Talkwall licence',
        accessibility: 'Accessibility statement',
        privacy: 'Privacy statement',
        faq: 'Frequently asked questions',
        feedback: 'Give us feedback about Talkwall',
      },
    },
  })
</script>
